<template>
  <header class="dashboard-metric-header">
    <div class="sales-insights-tooltips">
      <DashboardTooltip>
        <template v-slot:tooltipText>
          <span class="tooltip-message">{{ retailerAttributionMessage }}</span>
        </template>
        <template v-slot:mainText>
          Retailer Data
        </template>
      </DashboardTooltip>
      <DashboardTooltip>
        <template v-slot:tooltipText>
          <span class="tooltip-message">{{ attributionWindowMessage }}</span>
        </template>
        <template v-slot:mainText>
          Attributable Sales Data
        </template>
      </DashboardTooltip>
    </div>
  </header>
</template>
<script>
import DashboardTooltip from '../DashboardTooltip.vue';

export default {
  components: {
    DashboardTooltip,
  },
  data() {
    return {
      circleColor: '#4369F4',
      retailerAttributionMessage:
        'Data delivered varies by retailer. ' +
        'For a full list of data available by retailer, see the Sales Insights Methodology Doc' +
        ' or contact your Customer Success Manager.',
      attributionWindowMessage:
        'MikMak collects attributable sales data.' +
        ' For a list of required criteria and common causes' +
        ' of data not being captured, review the Reporting Methodology' +
        ' section in the MikMak Glossary.',
    };
  },
};
</script>
<style scoped>
  .dashboard-metric-header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    line-height: 140%;
  }

  .sales-insights-tooltips {
    display: flex;
    gap: 18px;
  }

  .tooltip-message {
    white-space: pre-wrap;
    line-height: 17px;
  }

</style>
